import { initDB, bulkPut, getAllFromStore, clearStore } from '../db/indexeddb.js';
import { chunkArray, validateCollections, buildExportPayload } from './importer.js';

const STORES = ['channels', 'videos', 'subscriptions', 'scans'];

export async function importPayload(payload, { onProgress } = {}) {
  if (!validateCollections(payload)) {
    throw new Error('Export JSON missing required collections.');
  }

  const db = await initDB();

  for (const store of STORES) {
    await clearStore(db, store);
  }

  for (const store of STORES) {
    const batches = chunkArray(payload[store]);
    for (let i = 0; i < batches.length; i += 1) {
      await bulkPut(db, store, batches[i]);
      if (onProgress) {
        onProgress({ store, current: i + 1, total: batches.length });
      }
    }
  }
}

export async function exportPayload() {
  const db = await initDB();
  const [channels, videos, subscriptions, scans] = await Promise.all([
    getAllFromStore(db, 'channels'),
    getAllFromStore(db, 'videos'),
    getAllFromStore(db, 'subscriptions'),
    getAllFromStore(db, 'scans')
  ]);

  return buildExportPayload({ channels, videos, subscriptions, scans });
}
